import { Http, Headers, Response, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from 'environments/environment';

export class BaseService {

    public host: string = environment.apiUrl

    protected token = sessionStorage.getItem('token')
    protected headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': this.token,
        'Access-Control-Allow-Origin': '*',
        'X-Device-Context': 'asap_authorized_access'
    })

    protected options = new RequestOptions({
        headers: this.headers
    });

    constructor(
        protected http: Http,
        protected basePath: string,
        protected entityName: string) { }

    getResources(params = {}) {
        return this.http.get(this.resourceUrl(null, params), this.options).map((res: Response) => res.json())
    }

    getResource(id, params = {}) {
        return this.http.get(this.resourceUrl(id, params), this.options).map((res: Response) => res.json())
    }

    createResource(data, params = {}) {
        return this.http.post(this.resourceUrl(null, params), JSON.stringify(data), this.options).map((res: Response) => res.json())
    }

    updateResource(data, params = {}) {
        const id = data.id;
        return this.http.put(this.resourceUrl(id, params), JSON.stringify(data), this.options).map((res: Response) => res.json())
    }

    updateCustom(data, params = {}) {
        return this.http.put(this.resourceUrl(null, params), JSON.stringify(data), this.options).map((res: Response) => res.json())
    }

    deleteResource(id, params = {}) {
        return this.http.delete(this.resourceUrl(id, params), this.options).map((res: Response) => res.status)
    }

    resourceUrl(id = null, params = {}) {

        const endpoint = [
            this.host,
            this.basePath,
            this.urlParameters(params),
            this.entityName,
            id
        ].filter(element => element != false).join('/').replace(/\/$/, '');

        let url = endpoint + this.queryString(params);

        let user: any = sessionStorage.getItem('loggedUser');
        if (user) {
            user = JSON.parse(user).data;
            if (url.indexOf('client_id') < 0) {
                if (url.indexOf('?') >= 0) {
                    url = url + '&';
                } else {
                    url = url + '?';
                }
                url = url + 'client_id=' + user.client_id;
            }
        }

        return url;
    }

    protected urlParameters(params) {
        const urlParameters = []

        for (const placeholder in params) {
            if (/.*_id$/.test(placeholder)) {
                urlParameters.push(`${placeholder}/${params[placeholder]}`)
            }
        }

        return urlParameters.join('/')
    }

    protected queryString(params) {
        let qry = "";

        if (params.router) {
            qry = `/${params.router}`
        }

        if (params.query) {
            qry += `?${params.query}`
        }

        return qry;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/loja/base.service.ts